import { render, staticRenderFns } from "./WelcomeHome.html?vue&type=template&id=6cfbd742&scoped=true&external"
import script from "./WelcomeHome.vue?vue&type=script&lang=js"
export * from "./WelcomeHome.vue?vue&type=script&lang=js"
import style0 from "./WelcomeHome.scss?vue&type=style&index=0&id=6cfbd742&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfbd742",
  null
  
)

export default component.exports